import classNames from 'classnames'
import styles from '../Map.module.scss'

export const CloseIcon = ({ radius }: { radius: number }): JSX.Element => (
  <svg style={{ width: radius, height: radius }} width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" fillRule="evenodd" clipRule="evenodd" d="M9.72066 0.279337C10.0931 0.651788 10.0931 1.25565 9.72066 1.6281L6.34876 5L9.72066 8.3719C10.0931 8.74435 10.0931 9.34821 9.72066 9.72066C9.34821 10.0931 8.74435 10.0931 8.3719 9.72066L5 6.34876L1.6281 9.72066C1.25565 10.0931 0.651788 10.0931 0.279337 9.72066C-0.0931125 9.34821 -0.0931125 8.74435 0.279337 8.3719L3.65124 5L0.279337 1.6281C-0.0931125 1.25565 -0.0931125 0.651788 0.279337 0.279337C0.651788 -0.0931125 1.25565 -0.0931125 1.6281 0.279337L5 3.65124L8.3719 0.279337C8.74435 -0.0931125 9.34821 -0.0931125 9.72066 0.279337Z" />
  </svg>
)

export const ResetButton = ({
  setBusinessId
}: {
  setBusinessId: (id: string | null) => void;
}): JSX.Element => (
  <button
    type="button"
    className={classNames(styles['popover-close-btn'], styles['popover-close-btn--reset'])}
    onClick={() => {
      setBusinessId(null)
    }}
    aria-label="Reset"
    title="Reset"
  >
    <CloseIcon radius={10} />
  </button>
)
